import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetDataSecurityActionPlanRequest = {
	applicationId: number;
};

export type GetDataSecurityActionPlanResponse = {
	text: string
};

export const getDataSecurityActionPlan =
	createGetEndpoint<GetDataSecurityActionPlanRequest, GetDataSecurityActionPlanResponse>(
		({ applicationId }) => `/api/v3/data-security/applications/${applicationId}/suggested-action`
	);
